module.exports = __webpack_public_path__ + "img/license.5e9097c6.jpg";